import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL, config } from '../../../config/config';

export const fetchNotifications = createAsyncThunk(
	'notifications/fetch',
	async (locationId, thunkAPI) => {
		try {
			const response = await axios.get(
				`${API_URL}/notifications/get-notifications?LocationId=${locationId}&page=1&limit=50`,
				config
			);
			return response.data.data;
		} catch (error) {
			return thunkAPI.rejectWithValue(error.message);
		}
	}
);

const notificationSlice = createSlice({
	name: 'notifications',
	initialState: {
		list: [],
		loading: false,
	},
	reducers: {
		addNotification: (state, action) => {
			state.list.unshift({
				...action.payload,
				id: action.payload.id ?? action.payload.NotificationId ?? Date.now(),
				IsSeen: false,
				read: false,
			});
		},

		markAsRead: (state, action) => {
			const n = state.list.find((n) => n.id === action.payload);
			if (n) {
				n.read = true;
				n.IsSeen = true;
			}
		},

		markAllAsRead: (state) => {
			state.list.forEach((n) => {
				n.read = true;
				n.IsSeen = true;
			});
		},
		removeNotification: (state, action) => {
			state.list = state.list.filter((n) => n.id !== action.payload);
		},
		clearNotifications: (state) => {
			state.list = [];
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchNotifications.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchNotifications.fulfilled, (state, action) => {
				state.loading = false;
				state.list = (action.payload || []).map((n) => ({
					...n,
					id: n.NotificationId,
					IsSeen: n.IsSeen ?? false,
					read: n.IsSeen ?? false,
				}));
			})
			.addCase(fetchNotifications.rejected, (state) => {
				state.loading = false;
			});
	},
});

export const {
	addNotification,
	markAsRead,
	markAllAsRead,
	removeNotification,
	clearNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
